module.exports = __webpack_public_path__ + "static/media/Galaxy Patrol.0faaca3c.jpg";